import store from '@/store'

export const role = {
  admin: "Admin",
  owner: "Owner",
  manager: "Manager",
  user: "User",
};

export const validateRole = (roles) => {
  const currentRole = store.getters.currentRole

  return (!Array.isArray(roles) ? [roles] : roles).map(r => r.toLowerCase()).includes(currentRole.toLowerCase())
  
}
